var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgListBordered = function SvgListBordered(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 5.25C3.5 4.83579 3.83579 4.5 4.25 4.5H8.75C9.16421 4.5 9.5 4.83579 9.5 5.25C9.5 5.66421 9.16421 6 8.75 6H4.25C3.83579 6 3.5 5.66421 3.5 5.25Z",
    fill: "#082244"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 7.875C3.83579 7.875 3.5 8.21079 3.5 8.625C3.5 9.03921 3.83579 9.375 4.25 9.375H8.75C9.16421 9.375 9.5 9.03921 9.5 8.625C9.5 8.21079 9.16421 7.875 8.75 7.875H4.25Z",
    fill: "#082244"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 12C3.5 11.5858 3.83579 11.25 4.25 11.25H8.75C9.16421 11.25 9.5 11.5858 9.5 12C9.5 12.4142 9.16421 12.75 8.75 12.75H4.25C3.83579 12.75 3.5 12.4142 3.5 12Z",
    fill: "#082244"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 6C12.1642 6 12.5 5.66421 12.5 5.25C12.5 4.83579 12.1642 4.5 11.75 4.5H11.7463C11.332 4.5 10.9963 4.83579 10.9963 5.25C10.9963 5.66421 11.332 6 11.7463 6H11.75Z",
    fill: "#082244"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 8.625C12.5 9.03921 12.1642 9.375 11.75 9.375H11.7463C11.332 9.375 10.9963 9.03921 10.9963 8.625C10.9963 8.21079 11.332 7.875 11.7463 7.875H11.75C12.1642 7.875 12.5 8.21079 12.5 8.625Z",
    fill: "#082244"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 12.75C12.1642 12.75 12.5 12.4142 12.5 12C12.5 11.5858 12.1642 11.25 11.75 11.25H11.7463C11.332 11.25 10.9963 11.5858 10.9963 12C10.9963 12.4142 11.332 12.75 11.7463 12.75H11.75Z",
    fill: "#082244"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 2.625C0.5 1.58947 1.33947 0.75 2.375 0.75H13.625C14.6605 0.75 15.5 1.58947 15.5 2.625V15.375C15.5 16.4105 14.6605 17.25 13.625 17.25H2.375C1.33947 17.25 0.5 16.4105 0.5 15.375V2.625ZM2.375 2.25C2.16789 2.25 2 2.41789 2 2.625V15.375C2 15.5821 2.16789 15.75 2.375 15.75H13.625C13.8321 15.75 14 15.5821 14 15.375V2.625C14 2.41789 13.8321 2.25 13.625 2.25H2.375Z",
    fill: "#082244"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgListBordered, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/list-bordered.90f4c6e7.svg";
export { ForwardRef as ReactComponent };